import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Bug } from 'lucide-react';
import BugReportModal from '../layout/BugReportModal';

/**
 * Subtle feedback FAB — bottom-right (pairs visually with primary actions on that side).
 */
const GlobalBugButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const [currentUrl, setCurrentUrl] = useState(window.location.href);

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, [location]);

  return (
    <>
      <button
        type="button"
        onClick={() => {
          setCurrentUrl(window.location.href);
          setIsModalOpen(true);
        }}
        className="fixed z-40 bottom-[5.5rem] right-6 flex h-11 w-11 items-center justify-center rounded-full border border-gray-200 bg-white/95 text-gray-600 shadow-lg shadow-black/5 backdrop-blur-sm transition-all duration-200 hover:border-indigo-200 hover:bg-white hover:text-indigo-600 hover:shadow-md hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 dark:border-gray-600 dark:bg-gray-800/95 dark:text-gray-300 dark:hover:border-indigo-500/40 dark:hover:bg-gray-800 dark:hover:text-indigo-300 dark:focus-visible:ring-offset-gray-900 sm:bottom-[6.25rem] sm:right-8"
        title="Report an issue or send feedback"
        aria-label="Report an issue or send feedback"
      >
        <Bug className="h-5 w-5" strokeWidth={2} aria-hidden />
      </button>

      <BugReportModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} currentUrl={currentUrl} />
    </>
  );
};

export default GlobalBugButton;
